import React from "react"
import styled from "styled-components"
import Layout from "@components/Layout"
import Helmet from "@components/Helmet"
import Scripts from "@views/common/Scripts"
import Tabs from "../common/Tabs"
import BackToTop from "../common/BackToTop"
import NewsletterSignup from "@components/NewsletterSignup"
import ContentfulContent from "@cms/ContentfulContent"
import _ from "lodash-es"

const HOME_SLUG = "home"

const Recommendations = styled.div``

const Page: any = ({ location, data, pageContext }): any => {
  const contentfulContent = data?.contentfulPage?.content || []
  const navigationTabs = data?.contentfulPage?.navigationTabs || []
  const frosmoPosition = data?.globalData?.frosmoPositionOnHomePage

  const seoData = {
    title: data?.contentfulPage?.title || pageContext?.title,
    description: data?.contentfulPage?.description?.description,
    keywords: data?.contentfulPage?.keywords,
  }

  const [countdownTimer, renderedContent] = _.partition(
    contentfulContent,
    ({ __typename }) => __typename === "ContentfulCountdownTimer"
  )

  const layoutProps: any = {
    location,
    data,
  }

  if (countdownTimer[0]) {
    layoutProps.countdownTimer = countdownTimer[0]
  }

  return (
    <Layout {...layoutProps}>
      <Helmet {...seoData} />
      <Scripts />
      {navigationTabs.length > 1 && <Tabs tabs={navigationTabs} />}
      {/* {navigationTabs.length > 1 && <Tabs tabs={_tabs} />} */}

      {typeof frosmoPosition !== "undefined" &&
      pageContext.pageSlug === HOME_SLUG ? (
        <>
          <ContentfulContent
            content={[renderedContent.slice(0, frosmoPosition - 1)]}
          />
          <Recommendations
            dangerouslySetInnerHTML={{
              __html: `<div id="frosmo-home-reco-1"></div><div id="frosmo-home-reco-2"></div><div id="frosmo-home-reco-3"></div><div id="frosmo-home-reco-4"></div>`,
            }}
          />
          <ContentfulContent
            content={renderedContent.slice(frosmoPosition - 1)}
          />
        </>
      ) : (
        <ContentfulContent content={renderedContent} />
      )}
      {data?.contentfulPage?.includeBackToTop && <BackToTop />}
      {data?.contentfulPage?.includeNewsletterSignup && <NewsletterSignup />}
    </Layout>
  )
}

export default Page
